import Header32 from './Header32'
export default Header32
